import { memoize } from 'lodash';

export const Color = {
  BLACK: '#000000',
  WHITE: '#ffffff',
};

/* Hex to RGB conversion:
 * http://www.javascripter.net/faq/hextorgb.htm
 */
const cutHex = memoize((h) => {
  return h.charAt(0) == '#' ? h.substring(1, 7) : h;
});
const hexToR = memoize((h) => {
  return parseInt(cutHex(h).substring(0, 2), 16);
});
const hexToG = memoize((h) => {
  return parseInt(cutHex(h).substring(2, 4), 16);
});
const hexToB = memoize((h) => {
  return parseInt(cutHex(h).substring(4, 6), 16);
});

export const computeTextColor = memoize((color) => {
  const r = hexToR(color);
  const g = hexToG(color);
  const b = hexToB(color);

  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? Color.BLACK : Color.WHITE;
});
